import { render, staticRenderFns } from "./ProductFormEmbed.vue?vue&type=template&id=0cf6e22f&scoped=true"
import script from "./ProductFormEmbed.vue?vue&type=script&lang=ts"
export * from "./ProductFormEmbed.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf6e22f",
  null
  
)

export default component.exports